import { render, staticRenderFns } from "./billComp.vue?vue&type=template&id=f29e9066"
import script from "./billComp.vue?vue&type=script&lang=js"
export * from "./billComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports